export default __webpack_public_path__ + "static/images/advanced-quotes.b2bdaf8f.png";